var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', [_c('b-alert', {
    staticClass: "sa_note",
    attrs: {
      "show": "",
      "variant": "light"
    }
  }, [_c('div', [_c('strong', [_vm._v("INV狀態碼對照")]), _vm._v(" —— 此案場 INV 回報的狀態碼代表什麼。 ")]), _c('ul', {
    staticClass: "mb-0 mt-1"
  }, [_c('li', [_vm._v(" 依「INV主檔」填的品牌型號，從品牌庫帶入對應的狀態碼："), _c('strong', [_vm._v("此案場還沒有資料時會自動帶入")]), _vm._v("， 之後 INV主檔改了品牌，再按「由品牌庫帶入」補上（已有的列不會被覆蓋）。 品牌庫找不到型號完全相同的，會帶入同品牌的每一組，請刪掉用不到的。 ")]), _c('li', [_c('strong', [_vm._v("是否視為運轉中")]), _vm._v("：只有「是」的狀態才會進入分析，影響全部規則。 降載、限功率類的狀態也要填「是」，否則降載相關的異常永遠不會觸發。表裡沒列的碼一律當作非運轉中。 ")]), _c('li', [_c('strong', [_vm._v("是否可免責停機")]), _vm._v("：填「是」的停機時段不計入妥善率的不可用時間（例：計畫維護）。 ")])])]), _c('b-alert', {
    staticClass: "mx-1 my-2 py-2 sc_hint",
    attrs: {
      "show": !!_vm.notice,
      "variant": _vm.noticeVariant,
      "dismissible": ""
    },
    on: {
      "dismissed": function dismissed($event) {
        _vm.notice = '';
      }
    }
  }, [_vm._v(" " + _vm._s(_vm.notice) + " ")]), _c('MasterDataTable', _vm._g({
    ref: "table",
    attrs: {
      "table": "site_inverter_status_codes",
      "def": _vm.def,
      "site-code": _vm.siteCode
    },
    scopedSlots: _vm._u([{
      key: "actions",
      fn: function fn() {
        return [_c('b-button', {
          staticClass: "md_btn",
          attrs: {
            "size": "sm",
            "disabled": !_vm.siteCode || _vm.bringing,
            "title": "依 INV主檔的品牌型號，從品牌庫帶入狀態碼；已有的列略過"
          },
          on: {
            "click": function click($event) {
              return _vm.bring(false);
            }
          }
        }, [_c('i', {
          staticClass: "fas fa-download",
          class: {
            'fa-spin': _vm.bringing
          }
        }), _vm._v(" 由品牌庫帶入 ")])];
      },
      proxy: true
    }])
  }, _vm.$listeners))], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };